var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProgress3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 8,
    viewBox: "0 0 112 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    rx: 4,
    fill: "#404041"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    width: 8,
    height: 8,
    rx: 4,
    fill: "#404041"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    width: 18,
    height: 8,
    rx: 4,
    fill: "#DB0025"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 49.8335,
    width: 8,
    height: 8,
    rx: 4,
    fill: "#404041"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 63.1665,
    width: 8,
    height: 8,
    rx: 4,
    fill: "#404041"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 76.5,
    width: 8,
    height: 8,
    rx: 4,
    fill: "#404041"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 89.8335,
    width: 8,
    height: 8,
    rx: 4,
    fill: "#404041"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 103.167,
    width: 8,
    height: 8,
    rx: 4,
    fill: "#404041"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgress3);
export default __webpack_public_path__ + "static/media/progress3.2ef6c7d8ad3de0b3e0cffb86993341c3.svg";
export { ForwardRef as ReactComponent };